/**
 * Фильтры «Версия клиента» / «Версия установки»
 * =============================================
 *
 * Общие константы и проверки. Допустимые значения и лимиты совпадают с
 * server/src/utils/versionFilter.ts: всё, что не проходит там, сервер молча
 * отбросит, поэтому клиент не должен сохранять такие значения из ссылки.
 */

// Максимум версий в одном фильтре (серверный MAX_VERSIONS)
export const MAX_SELECTED_VERSIONS = 50;

const MAX_VERSION_LENGTH = 32;
const VERSION_PATTERN = /^[0-9A-Za-z._-]+$/;

const isValidVersion = (value) =>
  typeof value === 'string' && value.length > 0 && value.length <= MAX_VERSION_LENGTH && VERSION_PATTERN.test(value);

/** Оставляет только допустимые уникальные версии, не больше MAX_SELECTED_VERSIONS. */
export const sanitizeVersions = (versions) =>
  [...new Set((Array.isArray(versions) ? versions : []).filter(isValidVersion))].slice(0, MAX_SELECTED_VERSIONS);

/** Задан ли хотя бы один из двух фильтров версий. */
export const hasVersionFilter = (clientVersions, installVersions) =>
  (clientVersions?.length || 0) > 0 || (installVersions?.length || 0) > 0;
